import { Col, Row, Table, Tooltip } from "antd";
import {
  LoadingOutlined,
  DownloadOutlined,
  EyeOutlined,
  FileOutlined,
  FlagTwoTone
} from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import { Button, Modal, Form, Alert, Space, Spin, Select } from "antd";
import { useMutation } from "react-query";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import HeadingBack from "../../../component/HeadingBack";
import { usePermission } from "../../../hooks/usePermission";
import { DashboardServices } from "../../../redux/Services";
import { FhirResource, fhirVersions, Patient } from "fhir-react";
import RenderFHIR from "./fhir";
import {
  DownloadReport,
  DECODEBASE
} from "../../../redux/Services/AbhaServices";
import AbhaLinkedFilter from "../AbhaFilter";
import { DateFormatWithTime, UserId } from "../../../utils";
import Loader from "./loader";
const { Option } = Select;
const DataReceived = () => {
  const permission = usePermission("HIU Dashboard", "List");
  const [value, setValue] = useState("");
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [decodeResData, setdecodeResData] = useState("");
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [isFilter, setisFilter] = useState(0);
  const [showBundle, setShowBundle] = useState(false);
  const [modalData, setModalData] = useState();
  const [bundleList, setBundleList] = useState(false);
  const [dataCompany,setDataCompany] = useState('');
  const [fhirBundles, setFhirBundles] = useState([]);
  const [viewModalData, setViewModalData] = useState([]);
  const [viewModalDataShow, setViewModalDataShow] = useState(false);
  // const [loader, setloader] = useState(true);
  const [filter, setFilter] = useState({});
  const HiuDataRequest = useSelector(
    (state) => state.dashboard.HiuDataRequest || []
  );
  const totalDataRequestSentLogs = useSelector(
    (state) => state.dashboard.totalHiuDataRequest || []
  );
  const DECODEBASEData = useSelector(
    (state) => state.abhaCreated.DECODEBASEData || []
  );
  const dataDecryption = useSelector(
    (state) => state.abhaCreated.DownloadReport || []
  );
  const { mutate: fetchHiuDataReceive, isLoading: loader2 } = useMutation(
    (data) => dispatch(DashboardServices.fetchHiuDataReceive(data))
  );
  // const { mutate: getDownloadReport, isLoading: loader1 } = useMutation(
  //   (data) => dispatch(DownloadReport(data, navigate))
  // );
  const { mutate: decodeBase, isLoading: loader } = useMutation((data) =>
    dispatch(DECODEBASE(data, navigate))
  );
  const [modal1Open, setModal1Open] = useState(false);
  const [modal2open, setModal2Open] = useState(false);
  const [showLoader,setShowLoader] = useState(false);
  // const [loaderModal, setloaderModal] = useState(true);
  const [raw, setRaw] = useState(null);
  // console.log(HiuDataRequest)
  // useEffect(() => {
  //   fetchHiuDataReceive({ ...filter });
  //   return () => {};
  // }, [filter, offset, limit]);
  useEffect(() => {
    fetchHiuDataReceive({ page, limit, ...filter });
  }, [page, limit, filter]);
  // useEffect(() => {
  //   if (dataDecryption?.decryptedData) {
  //     setModalData(JSON.parse(dataDecryption?.decryptedData));
  //   }
  // }, [dataDecryption]);
  // console.log(limit)
  useEffect(() => {
    const filePath = DECODEBASEData.filePath;
    if (filePath) {
      const fileURL = filePath;
      let alink = document.createElement("a");
      alink.target = "_blank";
      alink.href = fileURL;
      alink.download = "LPLReport.pdf";
      alink.click();
      window.location.reload(false);
    }

    return () => {};
  }, [DECODEBASEData]);
  useEffect(() => {
    //   let responseData = dataDecryption;
    //   console.log(responseData, "()()*(");
    //   responseData = responseData.decryptedData
    //     ? JSON.parse(responseData?.decryptedData)
    //     : "";

    //   if (responseData) {
    //     const presentedForm = responseData;
    //     console.log(presentedForm.entry);
    //     decodeBase64(presentedForm.entry);
    //   }
    // if (dataDecryption.decryptedData) {
    //   setShowBundle(true);
    // }
    return () => {};
  }, [dataDecryption]);

  const showDocument = (input) => {
    try {
      console.log(input, "===)))");

      if (input.length > 0) {
        const attachment = input[0].resource.content?.[0]?.attachment;
        if (attachment?.data) {
          // Base64 PDF data
          const base64Data = attachment.data;

          // Convert base64 → byte array → Blob
          const byteCharacters = atob(base64Data);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], {
            type: attachment.contentType || "application/pdf"
          });

          // Create a link and trigger download
          const url = window.URL.createObjectURL(blob);
          console.log(url, "url");

          const link = document.createElement("a");
          link.href = url;
          link.download = "report.pdf"; // default name
          link.click();
          window.URL.revokeObjectURL(url);
        } else if (attachment?.url) {
          // If DocumentReference only has a URL
          window.open(attachment.url, "_blank");
        } else {
          console.warn("No file data found in DocumentReference");
        }
      }
    } catch (error) {
      console.log(error, "error in viewwing file");
    }
  };

  const decodeBase64 = async (item) => {
    item.map(async function (val, index) {
      if (val?.resource?.content?.data) {
        var presentedForm = val?.resource?.content.data;
        let _data = {};
        _data.stringToDecode = presentedForm;
        _data.customToken = true;
        decodeBase(_data);
      } else {
        console.log("No presentedForm found");
      }
    });
  };
  const downloadReport = async (item) => {
    console.log(item,"item");
    let consentData=item.hiuFetchConsentDetailsLog?.response_raw_data? JSON.parse(item.hiuFetchConsentDetailsLog.response_raw_data):null;
    setDataCompany(consentData?.consent?.consentDetail?.hip?.name ||consentData?.consent?.consentDetail?.hip?.id||"");

    var fhirData = item?.fhir_data ? JSON.parse(item?.fhir_data) : null;
    setShowLoader(true);

    if (fhirData && fhirData?.decryptedData?.entry) {
      decodeBase64(fhirData?.decryptedData?.entry);
      fhirData.customToken = true;
      // convertBase64Download(_data);
    } else if (fhirData && fhirData.entry) {
      // fhirData.customToken = false;
    } else {
      var rawData = item || "{}";
      let downloadReport = {
        artefactId: `${rawData?.artefact_id || ""}`
      };
      let _data = { ...downloadReport };
      _data.customToken = true;
      const downlaodReponse = await DownloadReport(_data);
      if (downlaodReponse.status === 200) {
        // console.log(, "===");
        if (
          Array.isArray(downlaodReponse.data.data) &&
          downlaodReponse.data.data.length > 0
        ) {
          setFhirBundles(downlaodReponse.data.data);
        }
        

        // const jsonData = downlaodReponse.data.data.decryptedData
        //   ? JSON.parse(downlaodReponse.data.data.decryptedData)
        //   : "";
        // if (jsonData) {
          //   setModalData(jsonData);
          // }
        }
        setShowLoader(false);
      // console.log(downlaodReponse, "===))");
    }
    return false;
  };

  useEffect(() => {
    if (fhirBundles.length > 0) {
      setBundleList(true);
    }
  }, [fhirBundles]);

  useEffect(() => {
    if (modalData) {
      setShowBundle(true);
    }
  }, [modalData]);

  const columns = [
    {
      title: "S.No.",
      dataIndex: "sno",
      key: "sno",
      className: "table_first_col",
      render: (value, item, index) => (page - 1) * 10 + index + 1
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      className: "abha-link-action",
      render: (value, item, index) => {
        const data = item?.hiuFetchConsentDetailsLog?.response_raw_data
          ? JSON.parse(item?.hiuFetchConsentDetailsLog.response_raw_data)
          : null;
        return (
          <>
            <Tooltip placement="top" title={"Download Report"}>
              <Button
                className="view-btn"
                type="primary"
                onClick={() => {
                  downloadReport(item);
                }}
              >
                {" "}
                <DownloadOutlined />
              </Button>
            </Tooltip>
          </>
        );
      }
    },
    {
      title: "Artifact Id",
      dataIndex: "artefact_id",
      key: "request_id",
      className: "text-capitalize"
      // render: (value, item, index) => {
      //     return (
      //         <>{JSON.parse(item?.response_raw_data || "{}")}</>
      //     )
      // }
    },
    {
      title: "HIP",
      dataIndex: "requestor",
      key: "requestor",
      className: "text-capitalize",
      render: (value, item, index) => {
        const data = item?.hiuFetchConsentDetailsLog?.response_raw_data
          ? JSON.parse(item?.hiuFetchConsentDetailsLog.response_raw_data)
          : null;
        // console.log(data?.consent?.consentDetail);
        return <>{`${data?.consent?.consentDetail.hip.name} (${data?.consent?.consentDetail.hip.id})`}</>;
      }
    },
    {
      title: "Requester (HIU/HIP)",
      dataIndex: "requestor",
      key: "requestor",
      className: "text-capitalize"
    },

    // {
    //     title: 'Name',
    //     dataIndex: 'transactionId',
    //     key: 'transactionId',
    //     className: 'abha-link-date',
    //     render: (value, item, index) => {
    //         const data = item?.hiuFetchConsentDetailsLog?.response_raw_data ? JSON.parse(item?.hiuFetchConsentDetailsLog.response_raw_data) : null;
    //         console.log(data?.consent?.consentDetail.patient.id)
    //         return (

    //             <>{data?.consent?.consentDetail.patient.id}</>
    //         )
    //     }
    // },
    {
      title: "Abha Address",
      dataIndex: "transactionId",
      key: "transactionId",
      className: "abha-link-date",
      render: (value, item, index) => {
        const data = item?.hiuFetchConsentDetailsLog?.response_raw_data
          ? JSON.parse(item?.hiuFetchConsentDetailsLog.response_raw_data)
          : null;
        // console.log(data?.consent?.consentDetail);
        return <>{data?.consent?.consentDetail.patient.id}</>;
      }
    },
    {
      title: "Date Time",
      dataIndex: "created_at",
      key: "created_at",
      className: "abha-link-date",
      render: (value, item, index) => {
        return (
          <span>
            <>{moment.utc(item.createdAt).format("DD-MM-YYYY H:mm:ss")}</>
          </span>
        );
      }
    }

    // {
    //     title: 'FHIR Data',
    //     dataIndex: 'fhir_data',
    //     key: 'View',
    //     className: 'table_status_col view',
    //     render: (value, item, index) => {
    //         var phirData = JSON.parse(item?.fhir_data || null);
    //         return (
    //             phirData ?
    //                 <Button className="view-btn" type="primary" onClick={() => { setRaw(phirData); setModal1Open(true) }} > View</Button>
    //                 : ''
    //         )
    //     }
    // },
  ];
  return (
    <div>
      {loader2 ? (
        <Modal
          className="loder-modal1"
          centered
          open={true}
          onOk={null}
          onCancel={null}
          header={null}
          footer={null}
        >
          <Spin tip="Loading..." size="large"></Spin>
        </Modal>
      ) : (
        ""
      )}
      {loader ? <Loader /> : ""}
      {/* {loader1 ? <Loader /> : ""} */}

      <Row gutter={[10, 10]} align={"middle"}>
        <Col lg={3} md={24} sm={24} xs={24}>
          <HeadingBack
            title={"Data Received Log"}
            subHeading={`Records ${totalDataRequestSentLogs || 0}`}
          />
        </Col>
        <Col lg={19} md={12} sm={24} xs={24}>
          <AbhaLinkedFilter
            filter={filter}
            setFilter={setFilter}
            setPage={setPage}
          />
        </Col>
      </Row>
      <div className="tableResponsive mt-10">
        {showLoader && <Loader />}
        <Table
          rowKey="Id"
          bordered
          columns={columns}
          dataSource={Array.isArray(HiuDataRequest) ? HiuDataRequest : []}
          pagination={{
            current: page,
            pageSize: limit,
            total: totalDataRequestSentLogs,
            onChange: (current, pageSize) => {
              setPage(current);
              setLimit(pageSize);
            },
            showSizeChanger: true,
            showTotal: (total, range) =>
              `${range[0]}-${range[1]} of ${total} records`
          }}
        />

        <Modal
          style={{
            top: 20
          }}
          open={modal1Open}
          onOk={() => setModal1Open(false)}
          onCancel={() => setModal1Open(false)}
          footer={null}
        >
          {raw ? <pre>{JSON.stringify(raw, null, 2)}</pre> : ""}
        </Modal>

        <Modal
          className="full-modal"
          open={bundleList}
          onOk={() => setBundleList(false)}
          onCancel={() => setBundleList(false)}
          footer={null}
          width="60vw"
          style={{ top: 40, padding: 20 }}
          bodyStyle={{ minHeight: "40vh", overflowY: "auto", padding: "50px" }}
        >
          <h1>User Health Records {dataCompany}</h1>
          <div className="row m-4">
            {fhirBundles
              .filter((item) => item.decryptedData)
              .map((item, index) => {
                const bundle = JSON.parse(item.decryptedData);

                return (
                  <div
                    className="col-6"
                    key={index}
                    style={{
                      boxShadow: "0 3px 10px rgb(0 0 0 / 0.2)",
                      borderRadius: "10px",
                      padding: "10px",
                      margin: "15px 0"
                    }}
                  >
                    <div className="d-flex justify-content-between align-items-center">
                      <div>
                        <h6 className="mb-1">
                          {bundle.entry[0].resource?.section?.[0]?.title ||
                            "No Title"}
                        </h6>
                        <small className="text-muted">
                          {new Date(
                            bundle?.entry[0]?.resource?.date
                          ).toLocaleDateString()}
                        </small>
                      </div>
                      <div className="d-flex g-3">
                        <FileOutlined
                          style={{
                            fontSize: "20px",
                            cursor: "pointer",
                            color: "#1890ff",
                            marginRight: "10px"
                          }}
                          title="View Report"
                          onClick={() => {
                            const document = bundle.entry.filter(
                              (item) =>
                                item.resource.resourceType ===
                                "DocumentReference"
                            );
                            // console.log(document, "==+");
                            showDocument(document);

                            // setViewModalData(bundle);
                            // setViewModalDataShow(true);
                          }}
                        />
                        <EyeOutlined
                          style={{
                            fontSize: "20px",
                            cursor: "pointer",
                            color: "#1890ff"
                          }}
                          title="View Bundle Info"
                          onClick={() => {
                            setViewModalData(bundle);
                            setViewModalDataShow(true);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
        </Modal>
        <Modal
          className="full-modal"
          open={viewModalDataShow}
          onOk={() => setViewModalDataShow(false)}
          onCancel={() => setViewModalDataShow(false)}
          footer={null}
          width="80vw"
          style={{ top: 40 }}
          bodyStyle={{ minHeight: "60vh", overflowY: "auto", padding: "20px" }}
        >
          {/* {viewModalData && <RenderFHIR data={viewModalData} />} */}
          {
            <FhirResource
              fhirResource={viewModalData}
              fhirVersion={fhirVersions.R4}
              fhirIcons="https://www.gravatar.com/avatar/?s=50&r=any&default=identicon&forcedefault=1"
              withCarinBBProfile
            />
          }
        </Modal>
      </div>
    </div>
  );
};

export default DataReceived;
